namespace GeniuzPOS.RefundReasonReport {
    export class ReportRefundReasonByBillColumns {
        static columnsKey = 'RefundReasonReport.ReportRefundReasonByBill';
    }
}
